import { useNavigate } from "react-router-dom";
import { IFacultyYearlyReports } from "../../../../models/faculty/facultyReports";
import { connect, useDispatch } from "react-redux";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setReportsYearly } from "../../../../store/slices/master/reportSlice";
import { baseURL } from "../../../../constants/commonConstants";
import { getReports } from "../../../../action/masters/reportActionCreator";
import { ReportFrequency } from "../../../../models/dashboard/adminDashboard";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const YearlyFacultyReports = (props: IFacultyYearlyReports) => {
  const { snapShots, getYearlyReports, yearlyReports } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewALL = () => {
    navigate(ROUTER_URL.FACULTY_YEARLY_REPORTS);
  };

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.facultyReports);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getYearlyReports(
        pageBlockId.facultyReports,
        limit.three,
        ReportFrequency.Yearly
      );
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setReportsYearly([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Monthly and Annual Reports</h2>
          <a
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All"
            onClick={handleViewALL}
          >
            View All
          </a>
        </div>
        <div className="acc-resource mt-3 row">
          {yearlyReports?.map((report) => (
            <div className="col-lg-4 mb-3">
              <a href={report.url} target="_blank">
                <div className="card d-flex align-items-start flex-column">
                  <div className="reportimg">
                    <img src={baseURL + report.icon} alt="" />
                  </div>
                  <h2 className="para-hide-1">{report.name}</h2>
                  <p className="para-hide-2">{report.description}</p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getYearlyReports: (
    pageBlockId: number,
    noOfItems: number,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, noOfItems, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    yearlyReports: state.report.yearlyreports,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(YearlyFacultyReports);
